import { render, staticRenderFns } from "./CommentSectionComponent.vue?vue&type=template&id=6ae0452f&scoped=true&"
import script from "./CommentSectionComponent.vue?vue&type=script&lang=js&"
export * from "./CommentSectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentSectionComponent.vue?vue&type=style&index=0&id=6ae0452f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae0452f",
  null
  
)

export default component.exports